var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBusiness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85 7V6.95V6.55V6.5V6L5.85 5.99993C5.84999 5.99958 5.84998 5.99873 5.85108 5.99638C5.85249 5.99335 5.85617 5.98721 5.86427 5.97985C5.88096 5.96467 5.91048 5.95 5.95 5.95H7.05C7.08952 5.95 7.11904 5.96467 7.13574 5.97985C7.14383 5.98721 7.14751 5.99335 7.14892 5.99638C7.1501 5.9989 7.15 5.99969 7.15 6V6.5V6.55V6.95V7C7.15 7.00031 7.1501 7.0011 7.14892 7.00362C7.14751 7.00665 7.14383 7.01279 7.13574 7.02015C7.11904 7.03533 7.08952 7.05 7.05 7.05H5.95C5.91048 7.05 5.88096 7.03533 5.86427 7.02015C5.85617 7.01279 5.85249 7.00665 5.85108 7.00362C5.8499 7.0011 5.85 7.00031 5.85 7ZM1.63182 6.88222C1.31034 7.14818 1.1055 7.55017 1.1055 8V9C1.1055 9.83793 1.84329 10.45 2.6555 10.45H10.35C11.1622 10.45 11.9 9.83793 11.9 9V8C11.9 7.54903 11.6941 7.14614 11.3712 6.8802C11.9768 6.69721 12.45 6.17103 12.45 5.5V4C12.45 3.16207 11.7122 2.55 10.9 2.55H9.10614C8.87542 1.38564 7.76495 0.55 6.5 0.55C5.23505 0.55 4.12458 1.38564 3.89387 2.55H2.1C1.28779 2.55 0.55 3.16207 0.55 4V5.5C0.55 6.17695 1.02229 6.70177 1.63182 6.88222ZM6.12749 2.55C6.22876 2.48843 6.35466 2.45 6.5 2.45C6.64534 2.45 6.77124 2.48843 6.87251 2.55H6.12749Z",
    stroke: "currentColor",
    strokeWidth: 0.9
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBusiness);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Business.6629741aef19431b6dfbefacfb474493.svg";